<template lang="html">
  <table class="info-table">
    <tbody class="body-1">
      <tr
        v-for="header in headers"
        :key="header.text"
      >
        <td class="info-table--header font-weight-bold pr-4 pb-2 text--secondary">{{header.text}}</td>
        <td class="info-table--value text--primary pb-2">
          <slot
            :name="'item.'+header.value"
            :value="value[header.value]"
            :item="value"
            :header="header"
          >
            <span class="info-table--value-default">{{header.morph ? header.morph(value[header.value], value, header) : value[header.value]}}</span>
          </slot>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  name: 'InfoTable',
  props: {
    headers: {
      default: () => []
    },
    value: {
      default: () => ({})
    }
  }
}
</script>

<style lang="scss" scoped>
.info-table {
  max-width: 100%;
}

.info-table .info-table--header,
.info-table .info-table--value {
  vertical-align: top;
}

.info-table .info-table--value-default {
  word-break: break-all;
  white-space: pre-wrap;
}
</style>
